exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.5@core-js/library/modules/_wks-ext.js
// module id = 180
// module chunks = 16